import React, { useState, useEffect } from "react";
import { api } from "../../lib/api";
import { X, Phone } from "lucide-react";
import { toast } from "sonner";

export default function PhoneVerify({ open, initialPhone, onClose, onVerified }) {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState(initialPhone || "");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const [sentPhone, setSentPhone] = useState("");

  useEffect(() => { if (!cooldown) return; const t = setInterval(() => setCooldown((c) => Math.max(0, c - 1)), 1000); return () => clearInterval(t); }, [cooldown]);
  if (!open) return null;

  const send = async () => {
    if (!phone.trim()) { toast.error("Unesite broj telefona"); return; }
    setBusy(true);
    try { const { data } = await api.post("/auth/phone/send-code", { phone_number: phone }); setSentPhone(data.phone); setStep(2); setCooldown(30); toast.success("Kod je poslat SMS-om"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Greška pri slanju koda"); }
    finally { setBusy(false); }
  };
  const verify = async () => {
    if (code.trim().length < 4) { toast.error("Unesite kod iz SMS-a"); return; }
    setBusy(true);
    try { const { data } = await api.post("/auth/phone/verify-code", { phone_number: sentPhone || phone, code }); toast.success("Broj telefona verifikovan"); onVerified(data.phone); }
    catch (e) { toast.error(e?.response?.data?.detail || "Kod nije ispravan. Pokušajte ponovo."); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] max-w-md mx-auto flex items-end" data-testid="phone-verify-modal">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-full bg-white rounded-t-3xl p-6 animate-slide-up">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-display font-black text-xl flex items-center gap-2"><Phone size={18} /> Verifikacija broja</h2>
          <button onClick={onClose} className="bg-slate-100 rounded-full p-2"><X size={18} /></button>
        </div>
        {step === 1 ? (
          <>
            <p className="text-sm text-slate-500 mb-3">Potvrdite broj telefona da biste mogli da poručite. Poslaćemo vam SMS sa kodom.</p>
            <div className="flex items-center gap-2">
              <span className="px-3 py-3 rounded-2xl bg-slate-100 font-bold whitespace-nowrap">🇷🇸 +381</span>
              <input data-testid="pv-phone-input" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="65 123 4567"
                className="flex-1 px-4 py-3 rounded-2xl bg-slate-100 outline-none focus:ring-2 focus:ring-brand-red" />
            </div>
            <button data-testid="pv-send-code" disabled={busy} onClick={send}
              className="mt-4 w-full bg-brand-red text-white rounded-full py-3.5 font-display font-bold disabled:opacity-50">
              {busy ? "Slanje…" : "Pošalji kod"}
            </button>
          </>
        ) : (
          <>
            <p className="text-sm text-slate-500 mb-3">Unesite kod koji smo poslali na <b>{sentPhone}</b>.</p>
            <input data-testid="pv-code-input" inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="______"
              className="w-full text-center tracking-[0.5em] text-2xl font-display font-black px-4 py-3 rounded-2xl bg-slate-100 outline-none focus:ring-2 focus:ring-brand-red" />
            <button data-testid="pv-verify-code" disabled={busy} onClick={verify}
              className="mt-4 w-full bg-brand-red text-white rounded-full py-3.5 font-display font-bold disabled:opacity-50">
              {busy ? "Provera…" : "Potvrdi"}
            </button>
            <button data-testid="pv-resend" disabled={cooldown > 0 || busy} onClick={send}
              className="mt-2 w-full text-sm font-semibold text-slate-500 disabled:opacity-50">
              {cooldown > 0 ? `Pošalji ponovo za ${cooldown} s` : "Pošalji kod ponovo"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
